import React, { useEffect, useState } from 'react';
import FormPart from '../../../../../networking/models/FormPart';
import University from '../../../../../networking/models/University';

interface IProps {
    university?: University;
}

const UniversityGeneralConclusion: React.FC<IProps> = ({ university }) => {
    const [conclusion, setConclusion] = useState<FormPart>();

    useEffect(() => {
        if (university !== undefined) {
            let conclusion = university.formParts?.find(formPart => formPart.name.toLowerCase() === "conclusion");

            if (conclusion !== undefined) setConclusion(conclusion);
        }
    }, [university]);

    if (conclusion === undefined) return <></>;

    return (
        <div className="university-general__conclusion">
            <h2 className="university-general__conclusion-title">CONCLUSION</h2>

            <div className="university-general__conclusion-items">
                {
                    conclusion.active_questions.map((question, index) => {
                        const score = Math.ceil(parseInt(question.answers[0].value));

                        if (isNaN(score)) return null;

                        return (
                            <div key={index} className="university-general__conclusion-item">
                                <h3 className="university-general__conclusion-header">{question.name}</h3>

                                {/* <Rating rating={score} /> */}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default UniversityGeneralConclusion;
